import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from 'react';
export const OnHover = ({ children }) => {
    const [hovered, setHovered] = useState(false);
    return (_jsx("div", { style: { display: 'inline-flex' }, onMouseEnter: () => setHovered(true), onMouseLeave: () => setHovered(false), children: children(hovered) }));
};
